module.exports = __webpack_public_path__ + "img/icon_hint_normal.81d6376a.png";